import * as React from 'react';
import PropTypes from 'prop-types';

export type EventCallback = (e: Event) => any;

export interface TouchData {
	distX: number,
	distY: number,
	dist: number,
	startX: number,
	startY: number,
	endX: number,
	endY: number
}
export type TouchCallback = (tapData: TouchData) => any;

export type SwipeProps = {
	onSwipeLeft: TouchCallback,
	onSwipeRight: TouchCallback,
	onSwipeUp: TouchCallback,
	onSwipeDown: TouchCallback,
	onMouseMove: EventCallback,
	onClick: EventCallback,
	onTap: TouchCallback,
	minDistance: number,
	className: string
}

export type TouchStart = {
	startX: number,
	startY: number
}


export default class Swipe extends React.Component<SwipeProps>{
	
	static defaultProps = {
		// minimum distance to be considered a swipe
		minDistance: 50
	}

	cancelClick: boolean = false;
	touchStart: TouchStart;
	ignoreNextTouchEnd: boolean = false;
	ignoreTouchEnd: boolean = false;

	constructor(props){
		super(props);
		this.cancelClick = false;
	}

	onClick = (e): void => {
		let {onClick} = this.props;
		if (this.cancelClick){
			e.stopPropagation();
			e.preventDefault();
			this.cancelClick = false;
		}
		else{
			if (typeof onClick === 'function'){
				onClick.call(null, e);
			}
		}
	}

	onTouchStart = (e): void => {
		let {
			pageX,
			pageY
		} = e.touches[0];
		this.cancelClick = true;

		let numTouches = Object.keys(e.touches).length;
		if (numTouches === 1){
			this.touchStart = {
				startX: pageX,
				startY: pageY
			};
			this.ignoreNextTouchEnd = false;
		}
		else{
			this.ignoreNextTouchEnd = true;
		}
	}

	onTouchEnd = (e): void => {
		let {
			onSwipeRight,
			onSwipeLeft,
			onSwipeUp,
			onSwipeDown,
			onTap,
			minDistance
		} = this.props;

		let {
			pageX,
			pageY
		} = e.changedTouches[0];

		if (this.touchStart && !this.ignoreNextTouchEnd){
			let endX = pageX;
			let endY = pageY;
			
			let {
				startX,
				startY
			} = this.touchStart;

			let distY = Math.abs(pageY - startY);
			let distX = Math.abs(pageX - startX);
			let dist = Math.sqrt(
				Math.pow(endX - startX, 2)
				+ Math.pow(endY - startY, 2)
			);
			
			let arg = {
				distX,
				distY,
				dist,
				startX,
				startY,
				endX,
				endY
			};

			if (dist < minDistance){
				onTap(arg);
			}
			else{
				
				if (distY > distX){
					// more vertical
					if (startY < endY){
						if (typeof onSwipeDown === 'function'){
							onSwipeDown(arg);
						}
					}
					else if (startY > endY){
						if (typeof onSwipeUp === 'function'){
							onSwipeUp(arg);
						}
					}
				}
				else{
					// more horizontal
					if (startX > endX){
						if (typeof onSwipeLeft === 'function'){
							onSwipeLeft(arg);
						}
					}
					else if (startX < endX){
						if (typeof onSwipeRight === 'function'){
							onSwipeRight(arg);
						}
					}
				}
			}
		}
	}

	onMouseMove = (e) => {
		let {onMouseMove} = this.props;
		if (!this.cancelClick){
			if (typeof onMouseMove === 'function'){
				onMouseMove.call(null, e);
			}
		}
	}

	render(){
		let {
			onSwipeRight,
			onSwipeLeft,
			onSwipeUp,
			onSwipeDown,
			onTap,
			onClick,
			onMouseMove,
			minDistance,
			...props
		} = this.props;
		return (
			<div
				onTouchStart={this.onTouchStart}
				onTouchEnd={this.onTouchEnd}
				onClick={this.onClick}
				onMouseMove={this.onMouseMove}
				{...props}
			/>
		);
	}
}